import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Button } from '@/ui/primitives/button';

/** Botão de copiar que confirma com ✓ por um instante (o ícone muda no lugar). */
export function BotaoCopiar({ texto, rotulo }: { texto: string; rotulo: string }) {
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    if (!copiado) return;
    const t = setTimeout(() => {
      setCopiado(false);
    }, 1400);
    return () => {
      clearTimeout(t);
    };
  }, [copiado]);

  return (
    <Button
      variante="fantasma"
      tamanho="icone-sm"
      aria-label={copiado ? 'Copiado' : rotulo}
      onClick={() => {
        void navigator.clipboard.writeText(texto).then(() => {
          setCopiado(true);
        });
      }}
    >
      {copiado ? (
        <Check className="text-sucesso animate-surgir" aria-hidden />
      ) : (
        <Copy aria-hidden />
      )}
    </Button>
  );
}
